module.exports = __webpack_public_path__ + "img/hzkj.c0dfad83.png";